export default "__VITE_ASSET__CsAUNhnX__"